class EventProductPageController {
  constructor() {
    "ngInject";
  }

  $onInit() {
    // Expand the first product by default
    if (this.eventProducts && this.eventProducts.length > 0) {
      this.eventProducts[0]._expanded = true;
    }
  }

  toggleProduct(product) {
    product._expanded = !product._expanded;
  }

  save() {
    if (this.onSave) {
      this.onSave();
    }
  }

  back() {
    if (this.onBack) {
      this.onBack();
    }
  }
}

export default EventProductPageController;
